
export const  JDNET_LINK= "https://smtest.jdnet.deere.com/clarity/locations.cfm?showall";

export const VENDOR_MASTER= "Vendor Master Plant Parameters"
export const NEWREQUEST = "New Request";
export const SEARCH = "Search";
export const QUEUE = "Queue";
export const VMADMINS = "VMAdmins";
export const SECURITY = "Security";

export const DISPLAYREQUEST = "Display Request"
export const PLANT_APPROVERS="Plant Approvers"

export const GREY_COLOR = "#E5E6E8"
export const YELLOWORANGE_COLOR = "#e2cf00"
export const YELLOW_COLOR = "#ffff99"
export const PINK_COLOR = "pink"



//table header
export const PLANT = "Plant";
export const PLANT_NAME = "Plant Name";
export const LANDSCAPE = "Landscape";
export const SAP = "SAP";
export const ORG = "Org"
export const PURCH = "Purch";
export const COMPANY = "Company";
export const APPROVAL = "Approval"
export const APPROVER = "Approver"
export const CD = "Cd"
export const PATH = "Path";
export const VENDOR = "Vendor"
export const MASTER = "Master"
export const ADMIN = "Admin"
export const LAST_UPDATED = "Last Updated";
export const ACTION= "Action"
export const ON = "On (By)";
export const FIVE = "5" 


//Display Request

export const REQUEST = "Request";
export const REQUESTTYPE = "Request Type";
export const REQUESTEDON = "Request On";
export const REQUESTSTATUS = "Request Status";
export const REQUESTOPEN = "Request Open";
export const REQUESTBY = "Request By";
export const SUPPLIER = "Supplier";
export const SUPPLIERNAME = "Supplier Name";
export const SUPPLIERADD = "Supplier Physical Address";
export const ATTACH = "Attachment";

export const SEARCH_RESULTS="Search Results"

export const NEW_REQUEST1 = "Step 1 OF 5";
export const NEW_REQUEST2 = "Step 2 OF 5";
export const NEW_REQUEST3 = "Step 3 OF 5";
export const NEW_REQUEST4 = "Step 4 OF 5";
export const NEW_REQUEST5 = "Step 5 OF 5";

export const Month = "Month";
export const RemainingInventory = "Remaining Inventory";
export const ExpectedReceipts = "Expected Receipts";
export const ProjectedShipments = "Projected Shipments";
export const Inventory = "Inventory"
export const ONE = "1" 
export const TWO = "2" 
export const THREE = "3" 
export const FOUR = "4" 


export const ERROR_MESSAGE="Some error occurred. Please try after some time.";






